import { createSlice } from '@reduxjs/toolkit';
import axios from 'utils/axios';
import { ARYABHATTA_API_DOMAIN_V1, ON_TRIP_SURVEY_ENTITY_TYPE } from 'config';
import { dispatch } from 'store';
import { isValidArray } from 'views/pages/create-quote/EditAllTransfers/utils';
import { openSnackbar } from './snackbar';
import { extractErrorMessage } from 'views/pages/create-quote/utilities';
import { DEFAULT_ERROR_MESSAGE } from 'store/constant';

const initialState = {
    error: null,
    isOntripSurveyLoading: true,
    onTripSurveysResponses: []
};

// Start of Mapper Functions//

/* 
 Example mapper output
 {
        id: 1,
        QuestionText: 'What is the purpose of your Trip?',
        answers: [
            {
                answerType: '',
                imageType: IMAGE_ICON_TYPE.circularImage.key,
                imageSrc: 'https://picsum.photos/200/300',
                imageText: 'Bur Dubai',
                text: 'Bur Dubai'
            }
        ]
    },
*/

const makeCollaspeHeading = (title1, title2) => {
    let heading = '';
    if (title1) {
        heading += title1;
    }
    if (title2) {
        heading += `-${title2}`;
    }
    return `${heading}`;
};
const OnTripDataMapper = (responses) => {
    if (isValidArray(responses) && responses.length > 0) {
        const getIdAndResonses = responses?.map((responseItem) => ({
            id: responseItem?.code,
            surveyDate: responseItem?.created_at || '',
            collapseHeading: makeCollaspeHeading(responseItem?.entity_name, responseItem?.sub_component_title),
            questionsAndAnswers: (responseItem?.feedback_responses || [])?.map((feedbackItem) => {
                const id = feedbackItem?.code || '';
                const QuestionText = feedbackItem?.question_text || '';
                const answers = [...(feedbackItem?.feedback_answers || [])]?.map((answerItem) => {
                    const answerType = feedbackItem?.question_type || '';
                    const imageType = feedbackItem?.presentation_type || '';
                    const imageSrc = answerItem?.option_image || '';
                    const imageText = answerItem?.answer || '';
                    const text = answerItem?.answer || '';

                    return { answerType, imageType, imageSrc, imageText, text };
                });
                return { id, QuestionText, answers };
            })
        }));
        return getIdAndResonses;
    }

    return [];
};

// END of Mapper Functions//

const slice = createSlice({
    name: 'onTripSurvey',
    initialState,
    reducers: {
        setOntripSurveyResponse(state, action) {
            return {
                ...state,
                onTripSurveysResponses: action.payload || []
            };
        },
        setLoading(state, action) {
            return {
                ...state,
                isOntripSurveyLoading: action.payload
            };
        },
        resetState() {
            return {
                ...initialState
            };
        }
    }
});

export const { setOntripSurveyResponse, setLoading, resetState } = slice.actions;
export default slice.reducer;

export const getOnTripSurveyResponses = (bookingCode = '') => {
    const entityType = ON_TRIP_SURVEY_ENTITY_TYPE;
    const url = `${ARYABHATTA_API_DOMAIN_V1}frs/feedback/?entity_code=${bookingCode}&entity_type=${entityType}`;
    return async () => {
        try {
            dispatch(setLoading(true));
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            const OntripSurveyResponsesData = response?.data?.response || [];
            dispatch(setOntripSurveyResponse(OnTripDataMapper(OntripSurveyResponsesData)));
        } catch (error) {
            const errorResponse = error.response || {}; // Access the error response
            const errorData = errorResponse.data || {}; // Access the data in the error response
            const message = extractErrorMessage(errorData);
            dispatch(
                openSnackbar({
                    open: true,
                    message: message || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: { color: 'error' },
                    close: false
                })
            );
        } finally {
            dispatch(setLoading(false));
        }
    };
};
